<template>
    <item :title="title" :subTitle="subtitle" iconClass="ogc-icon-yinxingqia" :isActive="isActive">
        <template slot="buttons">
            <el-button class="button" type="primary" round plain @click="onShow">{{ buttonTitle }}</el-button>
        </template>

        <fc-dialog :title="buttonTitle" :visible.sync="visible">

            <div v-if="isActive">
                <el-steps :active="templateIndex" finish-status="success" align-center>
                    <el-step title="安全认证"></el-step>
                    <el-step title="绑定银行卡"></el-step>
                </el-steps>
            </div>

            <template v-if="isActive && templateIndex == 0">
                <el-alert show-icon title="需要进行安全认证"
                :description="step1Description" type="warning"></el-alert>
                
                <auto-form ref="form0" :rules="rules[0]" :form="form" :form-template="formTemplate[0]" :url="url.validateVCode"></auto-form>
            </template>
            <template v-else-if="!isActive || templateIndex == 1">
                <el-alert show-icon title="恭喜！安全验证成功！"  v-if="isActive"
                description="请输入您的新银行卡信息。" type="success" effect="dark"></el-alert>
                <el-alert show-icon title="填写银行卡信息"  v-else
                description="请输入您的新银行卡信息。" type="success"></el-alert>
                
                <auto-form ref="form1" :rules="rules[1]" :form="form" :form-template="formTemplate[1]" :url="url.save" beforeSave="beforeSave" @afterSaved="afterSaved"
                @saved="onSaved" :canEdit="true" :isEdit="false"></auto-form>
            </template>

            <div slot="footer" class="dialog-footer">
                <el-button type="warning" :disabled="uploading" plain @click="cancel"> 取 消 </el-button>
                <el-button type="primary" :disabled="uploading" @click="next" v-if="templateIndex < 1"> 下一步 </el-button>
                <el-button type="success" :disabled="uploading" @click="next" v-else> 确认更改 </el-button>
            </div>
        </fc-dialog>
    </item>
</template>

<script type="text/javascript">

import AutoForm from '@/components/AutoForm'
import FcDialog from '@/components/Dialogs/Dialog'
import Item from './OptionItem'

export default {
    components: {
        Item, FcDialog, AutoForm
    },
    props: {
        card: {
            type: String,
            default: null
        },
        bank: {
            type: String,
            default: null
        },
        username: {
            type: String,
            default: ''
        }
    },
    data() {
      // 原银行卡号
      let validateBankcard2 = (rule, value, callback) => {
        // if (!this.bankIsOk) {
        //   callback(new Error('您输入的银行卡号暂不支持！'));
        // } else {
          validateBankcard(rule, value, callback);
        // }
      }
        return {
            visible: false,
            uploading: false,
            vtype: 0,
            form: { Account:'', Bank:'', Province:'', City:'', AccountBank:'', OldAccount:'' },
            formTemplate: [
              [
                { col: 24, tips: '安全认证', type: 'tips' },
                { col: 24, label: '原银行卡号', prop: 'OldAccount' },
              ],
              [
                { col: 24, tips: '修改新银行卡', type: 'tips' },
                { col: 24, label: '银行账号', prop: 'Account', change: (v) => { this.onAccountChange(v); } },
                { col: 24, label: '开户银行', prop: 'Bank', type: 'select', options: [], change: () => { this.loadBankBranch(); }, filterable: true },
                { col: 12, label: '开户省份', prop: 'Province', type: 'select', options: [], change: () => { this.loadCity(); }, filterable: true },
                { col: 12, label: '开户地级市', prop: 'City', type: 'select', options: [], change: () => { this.loadBankBranch(); }, filterable: true },
                { col: 24, label: '开户银行支行', prop: 'AccountBank', type: 'select', options: [], filterable: true },
              ],


            ],
            rules: [
              {
                OldAccount: [
                  {
                    required: true,
                    message: '请输入银行账号',
                    trigger: 'blur'
                  },
                  {
                    validator: validateBankcard,
                    trigger: 'blur'
                  }
                ]
              },
              {
                Account: [
                  {
                    required: true,
                    message: '请输入银行账号',
                    trigger: 'blur'
                  },
                  {
                    validator: validateBankcard2,
                    trigger: 'blur'
                  }
                ],
                Bank: [{ required: true, message: '请选择开户行', trigger: 'change' }],
                Province: [{ required: true, message: '请选择开户行所在省份', trigger: 'change' }],
                City: [{ required: true, message: '请选择开户行所在城市', trigger: 'change' }],
                AccountBank: [{ required: true, message: '请选择开户银行支行', trigger: 'change' }],
              },


            ],
            url: {
                validateOldAccount: SZH.assets.api + "/Authen/VerifyCodeForBank",
                save: SZH.assets.api + "/Authen/SaveNewBankInfo",
                province: SZH.assets.api + "/Market/GetSelectProvince",
                city: SZH.assets.api + "/Market/GetSelectCity",
                bank: SZH.assets.api + "/Market/GetSelectBaseBank",
                bankBranch: SZH.assets.api + "/Market/GetSelectBankInfo",
                bankSearch: SZH.assets.api + "/Market/GetBankMapping",
            },
            templateIndex: 0,
            sendOk: false
        }
    },
    methods: {
        next() {
            var self = this;
            if(self.isActive && self.templateIndex == 0) {
                self.verify();
            }
            else {
                self.save();
            }
        },
        verify() {
            var self = this;
            self.$refs['form0'].validate(valid => {
                if (valid) {
                    self.uploading = true;
                    self.$http.post(self.url.validateOldAccount, { 
                        Data: {
                            OldAccount: self.form.OldAccount
                        }
                    }).then(result => { 
                       if (result.State == 1) {
                            self.$message.success("验证成功！");
                            self.templateIndex++;
                        } else {
                            self.$message.error(result.Message);
                        }
                        self.uploading = false;
                    }, () => { 
                        self.uploading = false;
                    });
                }
                else {
                    return false;
                }
            });
        },
        save() {
            this.$refs['form1'].submit();
        },
        beforeSave() {
            this.loading = true;
        },
        afterSaved() {            
            this.loading = false;
        },
        onSaved() {
            this.$message.success("银行卡修改成功");
            this.visible = false;
            this.$emit('saved');
        },
        onShow() {
            this.visible = true;
        },
        cancel() {
            this.visible = false;
        },
        changeType(val) {
            this.vtype = val;
        },
        loadProvince() {
            var self = this;
            self.$http.post(self.url.province, {}).then(result => {
                if (result.State == 1 && result.Data != null) {
                    self.formTemplate[1][3].options = result.Data;
                } else { }
            }, () => {
            });
        },
        loadCity() {
            var self = this;
            self.form.City = null;
            self.form.AccountBank = null;
            self.$http.post(self.url.city, { Data: self.form.Province }).then(result => {
                if (result.State == 1 && result.Data != null) {
                    self.formTemplate[1][4].options = result.Data;
                } else {
                    self.formTemplate[1][4].options = [];
                }
            }, () => {
            });
        },
        loadBanks() {
            var self = this;
            self.$http.post(self.url.bank, { Data: self.form.Province }).then(result => {
                if (result.State == 1 && result.Data != null) {
                    self.formTemplate[1][2].options = result.Data;
                } else {
                    self.formTemplate[1][2].options = [];
                }
            }, () => {
            });
        },
        loadBankBranch() {
            var self = this;
            if (self.form.City != '' && self.form.City != null && self.form.Bank != '' && self.form.Bank != null) {
                self.form.AccountBank = null;
                self.$http.post(self.url.bankBranch, {
                    Data: {
                        BankId: self.form.Bank,
                        CityId: self.form.City,
                    }
                }).then(result => {
                    if (result.State == 1 && result.Data != null) {
                        self.formTemplate[1][5].options = result.Data;
                    } else {
                        self.formTemplate[1][5].options = [];
                    }
                }, () => {
                });
            }
        },
        onAccountChange(v) {
            var self = this;
            if (v != null && v.length >= 6) {
                var s = v.substring(0, 6);
                self.$http.post(self.url.bankSearch, {
                    Data: s
                }).then(result => {
                    if (result.State == 1 && result.Data != null) {
                        self.form.Bank = result.Data.BankId;
                        self.bankIsOk = true;
                        self.loadBankBranch();
                    } else {
                        self.bankIsOk = false;
                    }
                }, () => {
                    self.bankIsOk = false;
                });
            }
        }
    },
    computed: {
        title() {
            return !this.isActive ? '未绑定银行卡' : '银行卡已绑定 ' + this.card;
        },
        subtitle() {
            return !this.isActive ? '绑定银行卡后可享受快捷服务' : this.bank;
        },
        buttonTitle() {
            return this.isActive ? '修改银行卡' : '绑定银行卡'
        },
        isActive() {
            return this.card != null;
        },
        step1Description() {
            return '您正在为帐号 ' + this.username + ' 修改银行卡，请输入原银行卡 ' + this.card + ' 的完整卡号。'
        }
    },
    created() {
    },
    mounted() {

    },
    watch: {
        visible(val) {
            if(val) {
                this.loadBanks();
                this.loadProvince();
                this.templateIndex = 0;
                for(var i in this.form) {
                    this.form[i] = '';
                }
            }
        }
    }
}
</script>

<style type="text/css" scoped>

.button {
    padding: 5px 10px;
}

.types {
    overflow: hidden;
    margin-top: 30px;
}

.type-item {
    width: calc(50% - 20px);
    border: 1px solid #CCC;
    padding: 30px 10px;
    text-align: center;
    float: left;
    cursor: pointer;
}
.type-item:last-child {
    float: right;
}

.type-item.active {
    border: 3px solid #0A529C;
}

.type-item > .icon {
    height: 150px;
    line-height: 150px;
}
.type-item:last-child > .icon {
    padding-top: 20px;
}

.type-item > h3 {
    font-weight: 700;
    line-height: 30px;
}

</style>



// WEBPACK FOOTER //
// src/views/Me/Info/components/ChangeBankCard.vue